module.exports = __webpack_public_path__ + "img/appnostu.8288a4f9.png";